// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"353":"contact","779":"error","945":"dashboard"}[chunkId] || chunkId) + "." + {"142":"c8fba352","283":"7b1f1d94","353":"3fc55c7c","453":"81965cb1","714":"4eb94e8b","760":"236dfacb","779":"cd8cc692","945":"680e76e7"}[chunkId] + ".css";
};